import {
  countMetricOptions,
  GoalMetric,
  MetricEntry,
  MetricTemplate,
  MetricUnit,
  MetricUnitIds,
} from '@griply/types';

export type BuildGoalMetricOptions = {
  template: MetricTemplate;
  startValue: string;
  targetValue: string;
  unitValue: string;
  entries: MetricEntry[] | null;
};

export const buildGoalMetric = ({
  template,
  startValue,
  targetValue,
  unitValue,
  entries,
}: BuildGoalMetricOptions): GoalMetric => {
  const isCount = countMetricOptions.includes(template.id);

  const templateUnit = unitValue
    ? template.unitOptions?.find(
        ({ id, name }) =>
          id === unitValue || Object.values(name).includes(unitValue),
      )
    : undefined;

  const unit: MetricUnit = {
    id: templateUnit?.id ?? MetricUnitIds.Custom,
    name: templateUnit?.name ?? unitValue,
    symbol: templateUnit?.symbol ?? null,
    format: templateUnit?.format ?? null,
  };

  const parsedStart = startValue.trim() ? Number(startValue) : null;
  const parsedTarget = targetValue.trim() ? Number(targetValue) : null;

  return {
    id: template.id,
    startValue: isCount ? null : parsedStart,
    targetValue: isCount ? null : parsedTarget,
    unit,
    entries,
  };
};
